import { HttpMethod } from '..';
import i18next from '../../i18n/i18nInit';
import { SnackbarAction, SnackbarClearAction } from './snackbar.types';

export const SNACKBAR_ENQUEUE = 'SNACKBAR_ENQUEUE';
export const SNACKBAR_CLEAR = 'SNACKBAR_CLEAR';

export function pushMessage(message: string): SnackbarAction {
	return {
		type: SNACKBAR_ENQUEUE,
		payload: { message, variant: 'success' }
	};
}

export function pushRequestSnackbar(
	section: string,
	method: HttpMethod,
	success: boolean,
	customMessage?: string
): SnackbarAction {
	const message: string =
		customMessage && success
			? customMessage
			: getPushMessage(section, method, success);
	return {
		type: SNACKBAR_ENQUEUE,
		payload: {
			message,
			variant: success ? 'success' : 'failure'
		}
	};
}

export function clearMessage(): SnackbarClearAction {
	return {
		type: SNACKBAR_CLEAR
	};
}

function getPushMessage(
	section: string,
	method: HttpMethod,
	success: boolean
): string {
	const requestResult: string = success
		? i18next.t('snackbar:successful')
		: i18next.t('snackbar:failed');

	const capitalizedSection: string = capitalizeFirstLetter(section);
	switch (method) {
		case 'GET':
			return i18next.t('snackbar:getMessage', {
				capitalizedSection,
				requestResult
			});
		case 'POST':
			return i18next.t('snackbar:postMessage', {
				capitalizedSection,
				requestResult
			});
		case 'PUT':
			return i18next.t('snackbar:putMessage', {
				capitalizedSection,
				requestResult
			});
		case 'DELETE':
			return i18next.t('snackbar:deleteMessage', {
				capitalizedSection,
				requestResult
			});
	}
}

function capitalizeFirstLetter(string: string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
}
